import { render, staticRenderFns } from "./AddCustomerDialog.vue?vue&type=template&id=915ea57c&scoped=true"
import script from "./AddCustomerDialog.vue?vue&type=script&lang=js"
export * from "./AddCustomerDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "915ea57c",
  null
  
)

export default component.exports